export const normalizeTimestampToMilliseconds = (timestamp: unknown): number | null => {
  if (timestamp === null || timestamp === undefined || timestamp === "") {
    return null;
  }

  if (timestamp instanceof Date) {
    const ms = timestamp.getTime();
    return Number.isNaN(ms) ? null : ms;
  }

  const rawValue =
    typeof timestamp === "string" ? Number(timestamp.trim()) : Number(timestamp);

  if (!Number.isFinite(rawValue)) {
    return null;
  }

  const numericValue = Math.trunc(rawValue);
  const absoluteDigits = Math.abs(numericValue).toString().length;

  if (absoluteDigits === 10) {
    return numericValue * 1000;
  }

  if (absoluteDigits === 13) {
    return numericValue;
  }

  return numericValue;
};

export const getDateFromMixedTimestamp = (timestamp: unknown): Date | null => {
  const normalizedTimestamp = normalizeTimestampToMilliseconds(timestamp);

  if (normalizedTimestamp === null) {
    return null;
  }

  const parsedDate = new Date(normalizedTimestamp);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const formatMixedTimestampDisplayDate = (
  timestamp: unknown
): string | null => {
  const parsedDate = getDateFromMixedTimestamp(timestamp);

  if (!parsedDate) {
    return null;
  }

  return parsedDate
    .toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })
    .replace(/ /g, "-");
};

export const getLocalDateKeyFromMixedTimestamp = (
  timestamp: unknown
): string | null => {
  if (timestamp === null || timestamp === undefined || timestamp === "") {
    return null;
  }

  if (typeof timestamp === "string") {
    const datePrefixMatch = timestamp.match(/^(\d{4}-\d{2}-\d{2})/);
    if (datePrefixMatch?.[1]) {
      return datePrefixMatch[1];
    }
  }

  const parsedDate = getDateFromMixedTimestamp(timestamp);
  if (!parsedDate) {
    return null;
  }

  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const day = String(parsedDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
